import { Button } from '@vkontakte/vkui';
import React, { useRef, useState } from 'react';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { useMinWidthBreakpoint } from 'reactApp/hooks/responsiveness/useMinWidthBreakpoint';
import { Tooltip } from 'reactApp/ui/Tooltip/Tooltip';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';

import styles from './EditorToolButton.css';

interface Props {
    text?: string;
    testId?: string;
    tooltipText?: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    icon: React.ReactNode;
}

export const EditorToolButton = ({ text, testId, tooltipText, onClick, icon }: Props) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const ref = useRef<HTMLDivElement>(null);

    const [largeBreakpointHit] = useMinWidthBreakpoint(BREAKPOINT_SM);
    const isMini = !largeBreakpointHit;

    return (
        <>
            {tooltipText && ref.current && tooltipOpen && (
                <Tooltip
                    radius={4}
                    minWidth={false}
                    fixed
                    placement={tooltipPlacements.BOTTOM_RIGHT}
                    smartPlacement={false}
                    noArrow
                    target={ref}
                >
                    <div className={styles.tooltip}>{tooltipText}</div>
                </Tooltip>
            )}
            <div ref={ref} className={styles.container}>
                <Button
                    data-test-id={testId}
                    hoverMode={styles.buttonHover}
                    before={icon}
                    onClick={onClick}
                    onEnter={() => setTooltipOpen(true)}
                    onLeave={() => setTooltipOpen(false)}
                    appearance="overlay"
                    mode="tertiary"
                >
                    {!isMini && text}
                </Button>
            </div>
        </>
    );
};
